type TopicSubscription = {
	id: string;
	topic: string;
};

type TopicSubscriptionIdCount = {
	count: number;
	id: string;
};

class TopicSubscriptions {
	private topicSubscriptions: Map<string, TopicSubscriptionIdCount> = new Map<string, TopicSubscriptionIdCount>();

	public add(topicSubscription: TopicSubscription): void {
		if (!this.topicSubscriptions.has(topicSubscription.topic)) {
			this.topicSubscriptions.set(topicSubscription.topic, {
				count: 1,
				id: topicSubscription.id,
			});
		} else {
			this.increaseSubscriptionCountForTopic(topicSubscription.topic);
		}
	}

	public clear(): void {
		this.topicSubscriptions.clear();
	}

	public decreaseSubscriptionCountForTopic(topic: string): void {
		if (this.topicSubscriptions.has(topic)) {
			const topicSubscriptionIdCount = this.topicSubscriptions.get(topic) as TopicSubscriptionIdCount;
			topicSubscriptionIdCount.count--;

			this.topicSubscriptions.set(topic, topicSubscriptionIdCount);
		}
	}

	public increaseSubscriptionCountForTopic(topic: string): void {
		if (this.topicSubscriptions.has(topic)) {
			const topicSubscriptionIdCount = this.topicSubscriptions.get(topic) as TopicSubscriptionIdCount;
			topicSubscriptionIdCount.count++;

			this.topicSubscriptions.set(topic, topicSubscriptionIdCount);
		}
	}

	public isAlreadySubscribed(topic: string): boolean {
		return this.topicSubscriptions.has(topic);
	}

	public map(): Map<string, TopicSubscriptionIdCount> {
		return this.topicSubscriptions;
	}

	public removeTopic(topic: string) {
		if (this.topicSubscriptions.has(topic)) {
			this.topicSubscriptions.delete(topic);
		}
	}

	public removeTopicSubscription(topic: string): void {
		if (this.topicSubscriptions.has(topic)) {
			this.decreaseSubscriptionCountForTopic(topic);
		}
	}

	public subscriptionCountForTopic(topic: string): number {
		if (this.topicSubscriptions.has(topic)) {
			const { count } = this.topicSubscriptions.get(topic) as TopicSubscriptionIdCount;
			return count;
		}

		return 0;
	}

	public subscriptionIdForTopic(topic: string): string {
		if (this.topicSubscriptions.has(topic)) {
			const { id } = this.topicSubscriptions.get(topic) as TopicSubscriptionIdCount;
			return id;
		}

		return '';
	}

	public updateSubscriptionIdForTopic(topicSubscription: TopicSubscription): void {
		if (this.topicSubscriptions.has(topicSubscription.topic)) {
			const topicSubscriptionIdCount = this.topicSubscriptions.get(
				topicSubscription.topic
			) as TopicSubscriptionIdCount;
			topicSubscriptionIdCount.id = topicSubscription.id;

			this.topicSubscriptions.set(topicSubscription.topic, topicSubscriptionIdCount);
		}
	}
}

export { TopicSubscriptionIdCount, TopicSubscriptions };
